<template>
  <span>{{ fullName }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue"
import AccountType from '@/types/account';

const props = defineProps<{
  updatedBy: AccountType | null
}>()

const fullName = computed(() => {
  let fullName = ''
  if (props.updatedBy) {
    fullName =  props.updatedBy.full_name
  }
  return fullName
})

</script>
